import type { TableSortState } from '../UI';

// The name column's sort key, shared because the default sort below has to
// point at the same column `getRoomNeedsColumns` renders. Nothing surfaces a
// mismatch: the table just renders unsorted under a header that still looks
// active, so this constant and the test beside it are the whole guard.
export const ROOM_NEED_NAME_COLUMN_KEY = 'name';

// Needs arrived in creation order, same as the room list they describe
// (REH-301). Ordering is Danish for every user; see SORT_LOCALE.
export const DEFAULT_ROOM_NEEDS_SORT: TableSortState = {
  key: ROOM_NEED_NAME_COLUMN_KEY,
  direction: 'asc'
};
